import * as React from 'react';
import { IAdvantageClaimsJobLossTypeState, IAdvantageClaimsJobLossType } from './AdvantageClaimsJobLossTypes';
import { IChildrenProps } from 'types/children';

export const AdvantageClaimsJobLossContext = React.createContext<IAdvantageClaimsJobLossTypeState | null>(null);

const AdvantageClaimsJobLossProvider: React.FC<IChildrenProps> = ({ children }) => {
    const initialState: IAdvantageClaimsJobLossType = {
        borrowerNameFirst: '',
        borrowerNameLast: '',
        borrowerMailingAddress: '',
        borrowerMailingCity: '',
        borrowerMailingState: undefined,
        borrowerMailingZip: '',
        borrowerEmail: '',
        borrowerPhone: '',
        borrowerSSN: '',
        borrowerDateOfBirth: '',
        borrowerComments: '',
        iuDateOfJobLoss: '',
        employerName: '',
        employerAddress: '',
        employerCity: '',
        employerState: undefined,
        employerZip: '',
        employerEmail: '',
        employerContactNumber: '',
        iuDateOfJobLossNotification: '',
        iuJobLossReason: '',
        iuDateLastDayWorked: '',
        iuIsLayoffTypicalAtThisTime: '',
        iuKnowledgeOfLayoffWhenHired: '',
        iuOccupationAtTimeOfSeparation: '',
        iuQualifyForStateUnemployment: '',
        iuRejectionStateBenefitsReason: '',
        iuSelfEmployed: '',
        eDeliveryConfirmation: '',
        iuFiledOnBehalfOf: undefined,
        submitterCompanyName: '',
        submitterNameFirst: '',
        submitterNameLast: '',
        submitterEmail: '',
        submitterPhone: ''
    };
    const [stateAdvantageClaimsJobLoss, setStateAdvantageClaimsJobLoss] =
        React.useState<IAdvantageClaimsJobLossType>(initialState);
    const saveState = (formData: IAdvantageClaimsJobLossType): void => {
        setStateAdvantageClaimsJobLoss({ ...formData });
    };
    const reinitialise = (): void => {
        setStateAdvantageClaimsJobLoss(initialState);
    };

    return (
        <AdvantageClaimsJobLossContext.Provider
            value={{
                contextStateAdvantageClaimsJobLoss: stateAdvantageClaimsJobLoss,
                updateContextStateAdvantageClaimsJobLoss: saveState,
                reinitialiseContextStateAdvantageClaimsJobLoss: reinitialise
            }}
        >
            {children}
        </AdvantageClaimsJobLossContext.Provider>
    );
};

export default AdvantageClaimsJobLossProvider;
